import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStyle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M14.4672 0C14.4787 2.04752 12.9158 3.7176 10.9757 3.72971C12.9158 3.7176 14.4974 5.36797 14.5088 7.41558C14.4974 5.36797 16.0606 3.69799 18.0001 3.68579C16.0606 3.69799 14.4787 2.04752 14.4672 0Z" }), /* @__PURE__ */ _jsx("path", { d: "M6.96649 3.20393C6.98939 7.28928 3.87109 10.6215 0 10.6457C3.87109 10.6215 7.02676 13.9145 7.0495 18C7.02676 13.9145 10.1458 10.5824 14.0155 10.5581C10.1458 10.5824 6.98939 7.28928 6.96649 3.20393Z" })]
});
export default SvgStyle;
